import { render, staticRenderFns } from "./deleteBtn.vue?vue&type=template&id=5b852890&scoped=true"
import script from "./deleteBtn.vue?vue&type=script&lang=js"
export * from "./deleteBtn.vue?vue&type=script&lang=js"
import style0 from "./deleteBtn.vue?vue&type=style&index=0&id=5b852890&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b852890",
  null
  
)

export default component.exports